import { render, staticRenderFns } from "./SimilarTopicsBottomSection.vue?vue&type=template&id=04dde596"
import script from "./SimilarTopicsBottomSection.vue?vue&type=script&lang=js"
export * from "./SimilarTopicsBottomSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports